import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {DoctorSelectorService} from "./doctor-selector.service";
import {AssignType, SelectedAnalyzer} from "../list-item";
import {I18nService} from "../../../i18n/i18n.service";
import {createAssignOptionsAndSelectInitialAnalyzer} from "./create-assign-options-and-select-initial-analyzer";
import {FoundMeasurement} from "../found-measurement";

export interface AnalyzerOption {
  doctorId: number | undefined;
  assignType: AssignType;
  text: string;
  testId: string;
}

@Component({
    selector: "doctor-selector",
    templateUrl: "doctor-selector.component.html",
    standalone: false
})
export class DoctorSelectorComponent implements OnInit {
  @Output() selectionChanged = new EventEmitter<SelectedAnalyzer | undefined>();

  @Input() measurement!: FoundMeasurement;

  @Input() markCurrentDoctor = true;

  @Input() selectingTechnicians = false;

  options: AnalyzerOption[] = [];

  selectedAnalyzerIndex: number | undefined = undefined;

  constructor(
    public doctorSelectorService: DoctorSelectorService,
    public localizationService: I18nService
  ) {
  }

  ngOnInit(): void {
    this.doctorSelectorService.doctors.subscribe(doctors => {
      const result = createAssignOptionsAndSelectInitialAnalyzer({
        doctors: doctors,
        assignType: this.measurement.assignType,
        doctor: this.measurement.doctor,
        chain: this.measurement.chain,
        ecgWorkFlow: this.measurement.ecgWorkflow,
        measurementType: this.measurement.type,
        selectingTechnicians: this.selectingTechnicians,
        globalTechnicianPoolLabel: this.localizationService.getLocalizedString("assignDoctorSelectorGlobalTechnicianPoolOptionLabel")
      });
      this.options = result.options;
      if (result.selectedAnalyzerIndex !== undefined) {
        this.itemSelected(result.selectedAnalyzerIndex);
      }
    });
  }

  itemSelected(selectedAnalyzerIndex: number) {
    this.selectedAnalyzerIndex = selectedAnalyzerIndex;
    const selectedAnalyzer = this.options[selectedAnalyzerIndex];
    this.selectionChanged.emit({
      doctorId: selectedAnalyzer.doctorId,
      assignType: selectedAnalyzer.assignType
    });
  }

  shouldMarkOptionAsCurrentlySelected(option: AnalyzerOption): boolean {
    return this.markCurrentDoctor
      && this.measurement.doctor !== undefined
      && this.measurement.assignType === "DOCTOR"
      && this.measurement.doctor.id === option.doctorId;
  }

}

